import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSportConfig } from '../context/SportConfig';
import '../styles/Auth.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const sportConfig = useSportConfig();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Something went wrong. Please try again.');
        return;
      }

      setSubmitted(true);
    } catch (err) {
      setError('Unable to reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>{sportConfig?.appEmoji || '🎾'} Forgot Password</h1>

        {submitted ? (
          <>
            <div className="success-message">
              Check your inbox! If that email is registered, a reset link is on its way.
              The link will expire in <strong>20 minutes</strong>.
            </div>
            <p className="auth-footer">
              <Link to="/login" className="auth-link">← Back to Login</Link>
            </p>
          </>
        ) : (
          <>
            <p className="auth-subtitle">
              Enter your account email and we'll send you a reset link.
            </p>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  placeholder="you@example.com"
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>

            <p className="auth-footer">
              Remembered it?{' '}
              <Link to="/login" className="auth-link">Back to Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
